// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GxFD","toggleWrap":"styles_toggleWrap__1oZCf","content":"styles_content__2LSiN","selectAreaCode":"styles_selectAreaCode__2GY7u"};